var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 39.8438H13.125C6.28125 39.8438 2.34375 35.9062 2.34375 29.0625V15.9375C2.34375 9.09375 6.28125 5.15625 13.125 5.15625H31.875C38.7188 5.15625 42.6562 9.09375 42.6562 15.9375V29.0625C42.6562 35.9062 38.7188 39.8438 31.875 39.8438ZM13.125 7.96875C7.7625 7.96875 5.15625 10.575 5.15625 15.9375V29.0625C5.15625 34.425 7.7625 37.0312 13.125 37.0312H31.875C37.2375 37.0312 39.8438 34.425 39.8438 29.0625V15.9375C39.8438 10.575 37.2375 7.96875 31.875 7.96875H13.125Z",
    fill: "url(#paint0_linear_300_7908)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4997 24.1312C20.9247 24.1312 19.331 23.6437 18.1122 22.6499L12.2435 17.9624C11.6435 17.4749 11.531 16.5937 12.0185 15.9937C12.506 15.3937 13.3872 15.2812 13.9872 15.7687L19.8559 20.4562C21.2809 21.6 23.6997 21.6 25.1247 20.4562L30.9935 15.7687C31.5935 15.2812 32.4935 15.3749 32.9622 15.9937C33.4497 16.5937 33.356 17.4937 32.7372 17.9624L26.8685 22.6499C25.6685 23.6437 24.0747 24.1312 22.4997 24.1312Z",
    fill: "url(#paint1_linear_300_7908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_7908",
    x1: 2.34375,
    y1: 20.8482,
    x2: 42.6562,
    y2: 20.8482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_7908",
    x1: 11.7134,
    y1: 19.3815,
    x2: 33.2731,
    y2: 19.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.57b18a3e179e59147f407f4873f2c380.svg";
export { ForwardRef as ReactComponent };